import styled from 'styled-components';
import {Typography} from '@/components/Typography';
import {interceptProps} from '@/styled-components/utils';
import {palette} from '@/styles';

export const Box = styled.div`
  padding: 8px 0;
`;

export const Item = styled(Typography)
  .attrs({
    as: Box,
    variant: 'medium12',
  })
  .withConfig({
    shouldForwardProp: interceptProps(['disabled']),
  })<{
  disabled?: boolean;
}>`
  cursor: pointer;
  font-weight: 700;
  color: ${palette.textPrimary};
  ${({disabled}) =>
    disabled &&
    `
    cursor: default;
    color: ${palette.disabled};
  `}
`;
